import { GridColDef } from "@mui/x-data-grid";

// Columnas por pestaña
export const columnsGenerales: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "marca", headerName: "Marca", width: 120, editable: true },
  { field: "modelo", headerName: "Modelo", width: 120, editable: true },
  { field: "anio", headerName: "Año", width: 90, editable: true }, // string en interface
  { field: "kilometrajeActual", headerName: "Km actual", type: "number", width: 110, editable: true },
];

export const columnsLiquidos: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "aceiteFiltroMotor", headerName: "Aceite/Filtro motor", type: "number", width: 150, editable: true },
  { field: "aceiteFrenos", headerName: "Liq. Frenos", type: "number", width: 150, editable: true },
  { field: "aceiteVolante", headerName: "Aceite Dir. Hid.", type: "number", width: 150, editable: true },
  { field: "aceiteCajaCambio", headerName: "Aceite Trans.", type: "number", width: 150, editable: true },
  { field: "aceiteDiferencial", headerName: "Aceite Dif.", type: "number", width: 150, editable: true },
  { field: "liquidoRefrigerante", headerName: "Liq. Refrig.", type: "number", width: 150, editable: true },
];

export const columnsFrenos: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "pastillasFrenos", headerName: "Mant. Prev. Frenos", type: "number", width: 150, editable: true },
  { field: "zapatas", headerName: "Camb. Past./Zap.", type: "number", width: 150, editable: true },
];

export const columnsRuedasRodamientos: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "llantasDelanteras", headerName: "Llantas del.", type: "number", width: 150, editable: true },
  { field: "llantasTraseras", headerName: "Llantas tras.", type: "number", width: 150, editable: true },
  { field: "alineacionBalanceo", headerName: "Alineación/Balanceo", type: "number", width: 150, editable: true },
  { field: "rotacionLlantas", headerName: "Rotación llantas", type: "number", width: 150, editable: true },
  { field: "amortiguadoresDelanteros", headerName: "Amort. del.", type: "number", width: 150, editable: true },
  { field: "amortiguadoresTraseros", headerName: "Amort. tras.", type: "number", width: 150, editable: true },
  
];

export const columnsMotor: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "bujias", headerName: "Bujías", type: "number", width: 150, editable: true },
  { field: "filtroAire", headerName: "Filt. Aire", type: "number", width: 150, editable: true },
  { field: "filtroGasolina", headerName: "Filt. Comb.", type: "number", width: 150, editable: true },
  { field: "bandaDistribucion", headerName: "Banda Dist.", type: "number", width: 150, editable: true },  
];

export const columnsVarios: GridColDef[] = [
  { field: "placa", headerName: "Placa", width: 120, editable: false },
  { field: "bateriaFecha", headerName: "Batería", type: "date", width: 150, editable: true },
  { field: "fechaMatricula", headerName: "Matrícula", type: "date", width: 150, editable: true }, 
  { field: "mantenimientoAireAcondicionadoFecha", headerName: "Mant. AC", type: "date", width: 150, editable: true },
  { field: "filtroAireAcondicionado", headerName: "Filt. Cab.", type: "number", width: 150, editable: true },
];


// Array final de columnas por pestaña
export const vehiculoColumns = [
  columnsGenerales,
  columnsLiquidos,
  columnsFrenos,
  columnsRuedasRodamientos,
  columnsMotor,
  columnsVarios,
];
